import { useLocale } from '@/context/LocaleContext';
import { resolveMediaUrl } from '@/lib/assetUrl';
import type { MessageInventoryItem } from '@/hooks/useMessages';

interface MessageInventoryPickerProps {
  items: MessageInventoryItem[];
  isLoading: boolean;
  title: string;
  cancelLabel: string;
  loadingLabel: string;
  onSelect: (item: MessageInventoryItem) => void;
  onClose: () => void;
}

export function MessageInventoryPicker({
  items,
  isLoading,
  title,
  cancelLabel,
  loadingLabel,
  onSelect,
  onClose,
}: MessageInventoryPickerProps) {
  const { t } = useLocale();
  return (
    <dialog id="inventory-modal" className="messages-dialog" aria-label={title} ref={node => {if (node && !node.open) node.showModal();}} onCancel={event => event.preventDefault()}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>{title}</h3>
          <button type="button" className="modal-close" aria-label={t('messages_cancel')} onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <div className="inventory-grid" id="inventory-grid">
            {isLoading ? (
              <div className="loading-inventory">{loadingLabel}</div>
            ) : items.length === 0 ? (
              <div className="loading-inventory">{t('settings_no_results')}</div>
            ) : (
              items.map((item) => (
                <div
                  key={item.id64}
                  className="inventory-item-selectable"
                  onClick={() => onSelect(item)}
                  onKeyDown={(e) => e.key === 'Enter' && onSelect(item)}
                  role="button"
                  tabIndex={0}
                >
                  <img src={resolveMediaUrl(item.icon)} alt="" className="inventory-item-icon" />
                  {item.isLocked ? <div className="inventory-item-lock-icon" /> : null}
                  <span className="inventory-item-name">{item.name}</span>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn-cancel" onClick={onClose}>
            {cancelLabel}
          </button>
        </div>
      </div>
    </dialog>
  );
}
